
import Tesseract from 'tesseract.js';

export interface OCRResult {
    text: string;
    confidence: number;
}

export const processImageForText = async (imageUrl: string, onProgress?: (progress: number) => void): Promise<OCRResult> => {
    try {
        const result = await Tesseract.recognize(
            imageUrl,
            'eng',
            {
                logger: m => {
                    if (m.status === 'recognizing text' && onProgress) {
                        onProgress(Math.round(m.progress * 100));
                    }
                }
            }
        );

        return {
            text: result.data.text,
            confidence: result.data.confidence
        };
    } catch (error) {
        console.error("OCR Error:", error);
        throw new Error("Failed to process image text.");
    }
};
